import React from "react";
import { connect } from "react-redux";
import { Alert, Breadcrumb, Icon, Layout } from "antd";
import { withNamespaces } from "react-i18next";
import get from "lodash/get";
import { Link } from "react-router-dom";

import classes from "./DelegationLogs.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDelegationLogRequest,
  getSettingsRolesRequest,
  getSitesRequest,
  getUsersLight,
  getDelegationLogStaffAllRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { getDelegationLogAdminReadPermission } from "../../reducers/user/selectors";
import DelegationLogForm from "./DelegationLogForm";

const routes = require("../../routes.json");

const { Content } = Layout;

class EditDelegation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      sites: [],
      staffImport: [],
      roles: null,
      delegationLog: null,
      errorMessage: this.props.delegationLogAdminReadPermission
        ? null
        : "Permission denied",
    };
  }

  async componentDidMount() {
    this.getDelegationLog();
    this.getSites();
    this.getUsers();
    this.getRolesList();
    this.getStaffImport();
  }

  getRolesList = async () => {
    try {
      const { data } = await getSettingsRolesRequest();
      this.setState({ roles: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  getStaffImport = async () => {
    try {
      const { data } = await getDelegationLogStaffAllRequest({
        id: get(this.props, "match.params.id"),
      });
      this.setState({ staffImport: data });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }
  };

  getUsers = async () => {
    try {
      const { data: users } = await getUsersLight();
      this.setState({ users });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
      }
    }
  };

  getSites = async () => {
    try {
      const { data } = await getSitesRequest();
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        this.props.logout();
      }
    }
  };

  getDelegationLog = async () => {
    try {
      const { data } = await getDelegationLogRequest({
        id: get(this.props, "match.params.id"),
      });
      this.setState({ delegationLogEdit: data });
    } catch (e) {
      this.setState({
        errorMessage: "Error",
      });
      if (e.response.status === 401) {
        this.props.logout();
      }
    }
  };

  render() {
    const {
      errorMessage,
      delegationLogEdit,
      staffImport,
      sites,
      roles,
    } = this.state;
    const { delegationLogAdminReadPermission } = this.props;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceDelegationLogs:Edit Delegation Log")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={routes.admin.delegationLogs}>
                  {this.props.i18n.t("NamespaceDelegationLogs:Delegation Logs")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("NamespaceDelegationLogs:Edit delegation log")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {!errorMessage && (
              <div>
                {delegationLogEdit &&
                delegationLogAdminReadPermission &&
                sites &&
                staffImport &&
                roles ? (
                  <DelegationLogForm
                    id={delegationLogEdit.id}
                    delegationLog={delegationLogEdit}
                    onSubmit={this.onDelegationLogEditSubmit}
                    onCancel={this.onDelegationLogEditHide}
                    sites={sites}
                    staffImport={staffImport}
                    rolesList={roles}
                  />
                ) : (
                  <Icon type="loading" />
                )}
              </div>
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogAdminReadPermission: getDelegationLogAdminReadPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(EditDelegation))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/EditDelegation.js